import * as React from 'react';
import { getTimePanelDropState } from '../selectors/timePanelDndStoreSelectors';
import { DragData, Droppable, DraggableItemTypes } from 'owa-dnd';
import { observer } from 'mobx-react-lite';

export interface TimePanelDropListenerProps {
    children?: React.ReactNode;
}

/**
 * This component handles listening for emails being dragged over the time panel
 * and accordingly modifying the store to show the drop hint.
 */
const TimePanelDropListener: React.FunctionComponent<TimePanelDropListenerProps> = observer(
    function TimePanelDropListener(props: TimePanelDropListenerProps) {
        const { children } = props;

        return (
            <Droppable
                dropViewState={getTimePanelDropState()}
                onDrop={doNothing}
                canDrop={canDropItemType}
                greedy={true}>
                {children}
            </Droppable>
        );
    }
);

function doNothing(dragInfo: DragData, pageX: number, pageY: number, target?: HTMLElement) {
    return;
}

/* "global" canDrop for the time panel that accepts any DraggableItemType that is consumed by a component within the time panel */
function canDropItemType(dragInfo: DragData): boolean {
    return (
        dragInfo.itemType === DraggableItemTypes.MailListRow ||
        dragInfo.itemType === DraggableItemTypes.Todo
    );
}

export default TimePanelDropListener;
